const emptyParagraph = (input: any): boolean => {
	if (input.type !== 'paragraph') {
		return false;
	}

	return !input.content?.some((node: any) => node.type !== 'text' || node.text.trim() !== '');
};

export const isEmptyAdf = (adf?: any): boolean => {
	if (!adf) {
		return true;
	}

	return !adf.content?.some((node: any) => !emptyParagraph(node));
};
